export type SupportRequestTheme = 'support' | 'bug' | 'feature'

export const requestThemeVars = (requestType: SupportRequestTheme) => {
  switch (requestType) {
    case 'bug':
      return `
        --support-request-primary-08: rgba(250, 118, 118, 0.08);
        --support-request-primary-12: rgba(250, 118, 118, 0.12);
        --support-request-primary-14: rgba(250, 118, 118, 0.14);
        --support-request-primary-15: rgba(250, 118, 118, 0.15);
        --support-request-primary-20: rgba(250, 118, 118, 0.2);
        --support-request-primary-30: rgba(250, 118, 118, 0.3);
        --support-request-primary-35: rgba(250, 118, 118, 0.35);
        --support-request-primary-40: rgba(250, 118, 118, 0.4);
        --support-request-primary-45: rgba(250, 118, 118, 0.45);
        --support-request-secondary-20: rgba(124, 58, 237, 0.2);
        --support-request-secondary-25: rgba(124, 58, 237, 0.25);
      `
    case 'feature':
      return `
        --support-request-primary-08: rgba(163, 230, 53, 0.08);
        --support-request-primary-12: rgba(163, 230, 53, 0.12);
        --support-request-primary-14: rgba(163, 230, 53, 0.14);
        --support-request-primary-15: rgba(163, 230, 53, 0.15);
        --support-request-primary-20: rgba(163, 230, 53, 0.2);
        --support-request-primary-30: rgba(163, 230, 53, 0.3);
        --support-request-primary-35: rgba(163, 230, 53, 0.35);
        --support-request-primary-40: rgba(163, 230, 53, 0.4);
        --support-request-primary-45: rgba(163, 230, 53, 0.45);
        --support-request-secondary-20: rgba(234, 184, 8, 0.2);
        --support-request-secondary-25: rgba(234, 184, 8, 0.25);
      `
    case 'support':
    default:
      return `
        --support-request-primary-08: rgba(124, 58, 237, 0.08);
        --support-request-primary-12: rgba(124, 58, 237, 0.12);
        --support-request-primary-14: rgba(124, 58, 237, 0.14);
        --support-request-primary-15: rgba(124, 58, 237, 0.15);
        --support-request-primary-20: rgba(124, 58, 237, 0.2);
        --support-request-primary-30: rgba(124, 58, 237, 0.3);
        --support-request-primary-35: rgba(124, 58, 237, 0.35);
        --support-request-primary-40: rgba(124, 58, 237, 0.4);
        --support-request-primary-45: rgba(124, 58, 237, 0.45);
        --support-request-secondary-20: rgba(109, 40, 217, 0.2);
        --support-request-secondary-25: rgba(109, 40, 217, 0.25);
      `
  }
}
